import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import YouPanel from "../HomePanel/YouPanel/YouPanel";
import "./Modal.css";
import "./YouModal.css";

// Desktop's account/profile entry point used to open a plain dropdown menu
// (Sign In/Out, Settings, User Details, ...) while mobile showed the full
// YouPanel as its own screen — wraps that same YouPanel in a dialog instead
// of duplicating its content in menu-item form, so both platforms present
// the same account UI.
const YouModal = (props) => {
  return (
    <div className="modal">
      <Modal
        {...props}
        animation={false}
        dialogClassName="you-modal-dialog"
        aria-labelledby="you-modal-title"
        centered
        onHide={props.onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="you-modal-shell">
            <button className="you-modal-close" onClick={props.onHide} aria-label="Close">
              <FontAwesomeIcon icon={solid("xmark")} />
            </button>
            <YouPanel />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default YouModal;
